import { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';

export default function OrdersCountChart({loadingState, response}) {
    const chartRef = useRef(null);
    const chartInstanceRef = useRef(null);

    useEffect(() => {
      if (loadingState || !chartRef.current || typeof ApexCharts === 'undefined') {
        return;
      }
        const getChartOptions = () => {
            return {
              series: response.data,
              colors: ["#43A047", "#1565C0", "#8E24AA", "#F9A825", "#EF5350", "#26A69A", "#102943", "#A9A9A9"],
              chart: {
                height: 350,
                width: "95%",
                type: "donut",
              },
              stroke: {
                colors: ["transparent"],
                lineCap: "",
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      name: {
                        show: true,
                        fontFamily: "Poppins, sans-serif",
                        offsetY: 20,
                      },
                      total: {
                        showAlways: false,
                        show: false,
                      },
                      value: {
                        show: true,
                        fontFamily: "Poppins, sans-serif",
                        offsetY: -20,
                        formatter: function (value) {
                          return value;
                        },
                      },
                    },
                    size: "70%",
                  },
                },
              },
              grid: {
                padding: {
                  top: -2,
                },
              },
              labels: response.labels,
              dataLabels: {
                enabled: false,
              },
              legend: {
                position: "right",
                horizontalAlign: "left",
                offsetY: 0,
                fontSize: '26px',
                fontFamily: "Poppins, sans-serif",
                fontWeight: 600,
                markers: {
                  width: 12,
                  height: 12,
                },
                itemMargin: {
                  vertical: 6,
                },
              },
              yaxis: {
                labels: {
                  formatter: function (value) {
                    return value;
                  },
                },
              },
              xaxis: {
                labels: {
                  formatter: function (value) {
                    return value;
                  },
                },
                axisTicks: {
                  show: false,
                },
                axisBorder: {
                  show: false,
                },
              },
            }
          }
          if (chartInstanceRef.current) {
              chartInstanceRef.current.destroy();
          }
          const chart = new ApexCharts(chartRef.current, getChartOptions());
          chartInstanceRef.current = chart;
          chart.render();

          return () => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
                chartInstanceRef.current = null;
            }
        };
    }, [loadingState, response]);

    return (
        <div className="bg-white rounded-lg shadow-sm p-4 md:p-6 orders-count-chart">
            <h3 className="component-heading">Wholesale Orders Count</h3>
            {loadingState ? <Skeleton /> : <div ref={chartRef}></div>}
        </div>
    );
}

function Skeleton() {
  return (
    <div className='flex items-center justify-around'>
    <div role="status" className="flex items-center justify-center rounded-full bg-gray-200 animate-pulse relative" style={{ height: '240px', width: '240px' }}>
      <div className="absolute bg-white rounded-full" style={{ height: '168px', width: '168px' }}></div>
      <div class="h-2 bg-gray-200 rounded-full max-w-[460px] mb-2.5"></div>
      <span className="sr-only">Loading chart...</span>
    </div>
    <div role="status" className="animate-pulse">
      <div style={{ display: 'flex', flexDirection: 'column', 'gap': '10px'}}>
      <div className='flex items-center justify-between' style={{ gap: '10px' }}>
        <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '10px' }}></div>
        <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '160px' }}></div>
      </div>
      <div className='flex items-center justify-between'>
        <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '10px' }}></div>
        <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '160px' }}></div>
      </div>
      <div className='flex items-center justify-between'>
        <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '10px' }}></div>
        <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '160px' }}></div>
      </div>
      <div className='flex items-center justify-between'>
        <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '10px' }}></div>
        <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '160px' }}></div>
      </div>
      <div className='flex items-center justify-between'>
        <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '10px' }}></div>
        <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '160px' }}></div>
      </div>
      <div className='flex items-center justify-between'>
        <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '10px' }}></div>
        <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '160px' }}></div>
      </div>
      <div className='flex items-center justify-between'>
        <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '10px' }}></div>
        <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '160px' }}></div>
      </div>
      </div>
      <span className="sr-only">Loading...</span>
  </div>
  </div>
  );
}